export const environment = {
	production: false,
	apiBaseUrl: 'https://api-dev.aldorartour.com/api/v1',
};
